import { render, staticRenderFns } from "./ContactPersonsSelect.vue?vue&type=template&id=47cf3c1b"
import script from "./ContactPersonsSelect.vue?vue&type=script&lang=js"
export * from "./ContactPersonsSelect.vue?vue&type=script&lang=js"
import style0 from "./ContactPersonsSelect.vue?vue&type=style&index=0&id=47cf3c1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports